/** @format */

import { CommonModule, NgOptimizedImage } from '@angular/common';

import { NgModule } from '@angular/core';
import { OptimizedImageComponent } from './optimized-image.component';

@NgModule({
	declarations: [OptimizedImageComponent],
	imports: [CommonModule, NgOptimizedImage],
	exports: [OptimizedImageComponent],
})
export class OptimizedImageComponentModule {}
